import { FC } from "react";
import { Theme } from "@mui/material";
import { Formik, FormikHelpers } from "formik";
import { Modal, ModalProps } from "@vilocnv/allsetra-core";
import InnerForm from "./children/InnerForm";
import { useTranslation } from "react-i18next";

export type XarReportFormProps = Pick<ModalProps, "open" | "onClose"> & {
  onSubmit: (values: any, formikHelpers: FormikHelpers<any>) => void;
  theme: Theme;
  dataLoading?: boolean;
  objects: Array<any>;
  submitting?: boolean;
  fetchOnDebounce: (value: string) => void;
  fetchAccountOnDebounce: (value: string) => void;
  onChange?: () => void;
  formInitialValues?: {};
  formValidations?: {};
  handleDateChange: (value: any) => void;
  dateValues: any;
  dateRangeLoading: boolean;
  searchedMinimalAccounts: Array<any>;
  searchedMinimalAccountsLoading: boolean;
  users: any[];
  accountKeys: any[];
  accountKeysLoading: boolean;
};

const GenerateXarReportForm: FC<XarReportFormProps> = ({
  open,
  onClose,
  onSubmit,
  theme,
  dataLoading = false,
  objects,
  submitting = false,
  fetchOnDebounce,
  fetchAccountOnDebounce,
  onChange,
  formInitialValues,
  formValidations,
  handleDateChange,
  dateValues,
  dateRangeLoading,
  searchedMinimalAccounts,
  searchedMinimalAccountsLoading,
  users,
  accountKeys,
  accountKeysLoading
}) => {
  const { t } = useTranslation(["translation", "formFieldsTranslation"]);

  return (
    <Formik
      //@ts-ignore
      initialValues={formInitialValues}
      validationSchema={formValidations}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnMount
    >
      {({ handleSubmit, isSubmitting, isValid, values, setFieldValue }) => {
        const isGenerateButtonDisabled = () => {
          if (values.reportMode === "byObject") {
            return false;
          }
          if (values.reportMode === "byDriver") {
            return !values.driverId || values.driverId === "";
          }
          return !isValid;
        };

        return (
          <Modal
            title={t("reports.generateXarReport")}
            theme={theme}
            open={open}
            onClose={() => {
              onClose();
            }}
            secondaryBtnProps={{
              text: t("buttonsText.cancel"),
              onClick: onClose
            }}
            primaryBtnProps={{
              type: "submit",
              text: t("buttonsText.generateReport"),
              loading: isSubmitting || submitting,
              // @ts-ignore
              onClick: handleSubmit,
              disabled: isGenerateButtonDisabled()
            }}
            size="customSize"
          >
            <InnerForm
              objects={objects}
              dataLoading={dataLoading}
              translator={t}
              fetchOnDebounce={fetchOnDebounce}
              fetchAccountOnDebounce={fetchAccountOnDebounce}
              onChange={onChange}
              //@ts-ignore
              values={values}
              setFieldValue={setFieldValue}
              handleDateChange={handleDateChange}
              dateValues={dateValues}
              dateRangeLoading={dateRangeLoading}
              searchedMinimalAccounts={searchedMinimalAccounts}
              searchedMinimalAccountsLoading={searchedMinimalAccountsLoading}
              users={users}
              accountKeys={accountKeys}
              accountKeysLoading={accountKeysLoading}
            />
          </Modal>
        );
      }}
    </Formik>
  );
};

export default GenerateXarReportForm;
